import React, { useState } from 'react'
import { Box, Grid } from '@material-ui/core'
import isEqual from 'lodash/isEqual'
import same from 'lodash/identity'

import Questionnaire from './CreateQuestionnaire'
import CreateQuestionnaireForm from './form'
import PreviewQuestionnaire from './PreviewQuestionnaire'
import GestionAprendizajeButton from './components/GestionAprendizajeButton'
import SearchQuestionnaire from './SearchQuestionnaire'
import NavigationButtonTop from './components/NavigationButtonTop'
import PublishQuestionnaire from './components/PublishQuestionnaire'
import ConfigurationQuestionnaire from './ConfigurationQuestionnaire'

function CreateInitalQuestionnaire() {
   const [viewQuestionnarie, setViewQuestionnarie] = useState('')

   return (
      <Grid
         container
         spacing={0}
         alignItems="center"
         style={{ padding: '0 3rem' }}
      >
         <PublishQuestionnaire />
         {!viewQuestionnarie && (
            <>
               <div style={{ marginLeft: '3rem' }}>
                  <NavigationButtonTop
                     setShowComfirmationModal={same}
                     isButtonBack={false}
                  />
               </div>
               <Box
                  sx={{
                     width: '80%',
                     display: 'flex',
                     gap: '1rem',
                     justifyContent: 'space-between',
                     alignContent: 'center',
                     height: '40px',
                     margin: '1rem'
                  }}
               >
                  <div style={{ marginLeft: '95px' }}>
                     <GestionAprendizajeButton
                        setViewQuestionnarie={setViewQuestionnarie}
                        isInitialCard
                     />
                  </div>
               </Box>
            </>
         )}

         {viewQuestionnarie === 'view-initial-form-questionnaire' && (
            <CreateQuestionnaireForm
               setViewQuestionnarie={setViewQuestionnarie}
            />
         )}
         {viewQuestionnarie === 'view-create-questionnaire' && (
            <Questionnaire setViewQuestionnarie={setViewQuestionnarie} />
         )}
         {viewQuestionnarie === 'view-preview-questionnaire' && (
            <PreviewQuestionnaire setViewQuestionnarie={setViewQuestionnarie} />
         )}
         {viewQuestionnarie === 'view-configuration-questionnaire' && (
            <ConfigurationQuestionnaire
               setViewQuestionnarie={setViewQuestionnarie}
            />
         )}
         <SearchQuestionnaire
            setViewQuestionnarie={setViewQuestionnarie}
            isComponentVisible={isEqual(
               viewQuestionnarie,
               'view-search-questionnaire'
            )}
         />
      </Grid>
   )
}

export default CreateInitalQuestionnaire
